const config = {
    environment: 'production',
    siteUrl: 'https://cloud.jpegmini.com',
    apiUrl: 'https://cloud.jpegmini.com/api',
    thumbnailsUrl: 'https://cloud.jpegmini.com/static/thumbnails',
    videoExtensions: ['mp4', 'm4v', 'mov', 'mkv', 'webm', 'avi'],
    imageExtensions: ['jpg', 'jpeg', 'heic', 'heif'],

    stripe: {
        publicKey: 'pk_live_51Rx6BMKIGCwQDiqs3k5FSesV4R0K9tMwjnWKcyBsO5zbIrEhNpk3tN8lOAZgsDnHVSLWX7W2kz1xObOejVQ1eCTs00WspPI1ch',
    },
};

config.allowedExtensions = config.videoExtensions.concat(config.imageExtensions);

export default config;